// extracted by mini-css-extract-plugin
export default {"wrapper":"MiddleSquare_wrapper__s1sNw"};